/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Employer API
 * OpenAPI spec version: 0.1.1
 */

export type EmployerRole = typeof EmployerRole[keyof typeof EmployerRole];


export const EmployerRole = {
  AccountManager: 'AccountManager',
  Admin: 'Admin',
  Marketeer: 'Marketeer',
  Lead: 'Lead',
  Conference: 'Conference',
  CustomerOnboarding: 'CustomerOnboarding',
  ConferenceOnboarding: 'ConferenceOnboarding',
} as const;
